import React from "react";
import styled from "styled-components";
import Rating from "./Rating.Map";

const InfoBoxContainer = styled.div`
  background: white;
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 10px;
  color: #5b5b5b;
  font-family: Roboto, Arial;
  font-size: 12px;
  user-select: text;
  max-width: 200px;
`;

const InfoBoxHeading = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: 14px;
  color: black;
`;

const InfoBoxText = styled.div`
  color: #5b5b5b;
  font-family: Roboto, Arial;
  font-size: 12px;
  -moz-user-select: text;
  -webkit-user-select: text;
  -ms-user-select: text;
  user-select: text;
  margin-top: 6px;
`;

const InfoBoxRating = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const InfoBoxReviewNumber = styled.div`
  display: inline-block;
  color: #e7711b;
  font-weight: 500;
  font-size: 14px;
`;

const InfoBoxCategory = styled.div`
  display: inline-block;
  color: inherit;
  font-weight: 500;
  font-size: 14px;
`;

function InfoBox({ place, mark }) {
  let placeCategory = mark.charAt(0).toUpperCase() + mark.slice(1);
  if(mark == 'dining'){
    placeCategory = 'Dining & Cafes';
  } else if(mark == 'salon') {
    placeCategory = 'Salon & Spa';
  }

  return (
    <InfoBoxContainer>
      <InfoBoxHeading>{place.name}</InfoBoxHeading>
      {place.vicinity && <InfoBoxText>{place.vicinity}</InfoBoxText>}
      {place.address && <InfoBoxText>{place.address}</InfoBoxText>}
      {place.rating && (
        <InfoBoxRating>
          <InfoBoxReviewNumber>{place.rating}</InfoBoxReviewNumber>
          <div>
            <Rating rating={place.rating} />
          </div>
        </InfoBoxRating>
      )}
      {place.user_ratings_total && (
        <div>{place.user_ratings_total} reviews</div>
      )}
      <InfoBoxCategory>{placeCategory}</InfoBoxCategory>
    </InfoBoxContainer>
  );
}

export default InfoBox;
